import _ from 'lodash'

export default function (Vue) {
    Vue.prototype.$track = function (category, action, label) {
        if (_.preload('app.debug')) {
            console.log('$track', {
                category,
                action,
                label
            })
        } else {
            if (Vue.prototype.$gtm) {
                Vue.prototype.$gtm.trackEvent({
                    event: 'ga',
                    category,
                    action,
                    label,
                    noninteraction: false
                })
            }

            if (window.fbq) {
                window.fbq.push('trackCustom', category, {
                    action,
                    label
                })
            }
        }
    }
}
